// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2u-1";
export var movingGradient = "_2u-4";
export var movingGradientBlock = "_2u-2";
export var skeleton = "_2u-0";
export var skeletonText = "_2u-3";